import { styled } from "@mui/material/styles";

import { HEX_W, GAP, ROW_STRIDE } from "./geometry";

export const TILE_W = HEX_W + GAP;
export const TILE_H = 2 * ROW_STRIDE;

const HEX_PATH =
  "M98.9805 3.36719C104.277 0.309242 110.765 0.213996 116.136 3.08105L116.651 3.36719L204.296 53.9688C209.763 57.1254 213.132 62.9601 213.132 69.2734V170.477C213.132 176.593 209.971 182.259 204.803 185.477L204.296 185.78L116.651 236.382C111.355 239.44 104.867 239.535 99.4961 236.668L98.9805 236.382L11.3359 185.78C5.8685 182.624 2.50011 176.79 2.5 170.477V69.2734C2.5 63.1573 5.66071 57.4905 10.8291 54.2725L11.3359 53.9688L98.9805 3.36719Z";

interface TileOptions {
  stroke: string;
  strokeWidth: number;
}

function buildHoneycombTileUrl({ stroke, strokeWidth }: TileOptions): string {
  const dx = TILE_W / 2;
  const dy = TILE_H / 2;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg"
         width="${TILE_W}" height="${TILE_H}"
         viewBox="0 0 ${TILE_W} ${TILE_H}">
      <defs>
        <path id="h" d="${HEX_PATH}" />
      </defs>
      <g fill="none" stroke="${stroke}" stroke-width="${strokeWidth}">
        <use href="#h" x="0" y="0" />
        <use href="#h" x="${dx}" y="${dy}" />
        <use href="#h" x="${-dx}" y="${dy}" />
        <use href="#h" x="${dx}" y="${-dy}" />
        <use href="#h" x="${-dx}" y="${-dy}" />
      </g>
    </svg>
  `;
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
}

const TILE_URL = buildHoneycombTileUrl({
  stroke: "#252327",
  strokeWidth: 1.5,
});

export const HoneycombBackground = styled("div")`
  display: flex;
  width: max-content;
  min-width: 100%;
  min-height: 100%;
  background-image: ${TILE_URL};
  background-repeat: repeat;
  background-size: ${TILE_W}px ${TILE_H}px;
  background-position: center;
`;
